// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "nav ul{list-style:none}nav ul li a{position:relative;padding-bottom:5px;transition:opacity ease-in .3s}nav ul a:hover{opacity:.7}nav ul a::after{content:\" \";position:absolute;bottom:0;width:100%;height:1px;background-color:#524648;left:0;display:block;transition:height ease-in .2s}nav ul a:hover::after{height:4px}nav ul li.active a::after{height:4px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
